export default "__VITE_ASSET__4d930c65__"